export class QuotesEnvironment {
  public static getName = () => 'benzinga-quotes';
  public static getEnvironment = (env: Record<string, string>) => ({
    analysisUrl: new URL(env.analysisUrl ?? 'https://www.benzinga.com/'),

    bullSayBearSayToken: env.bullSayBearSayToken ?? '',
    bullSayBearSayUrl: new URL(env.bullSayBearSayUrl ?? 'https://api.benzinga.com/'),

    delayedQuoteKey: env.delayedQuoteKey ?? '',
    delayedQuoteUrl: new URL(env.delayedQuoteUrl ?? 'https://data-api-next.benzinga.com/rest/'),

    logosKey: env.logosKey ?? '',
    logosUrl: new URL(env.logosUrl ?? 'https://api.benzinga.com/api/'),

    peersUrl: new URL(env.peersUrl ?? 'https://www.benzinga.com/api-next/'),

    scheduleKey: env.scheduleKey ?? '',
    scheduleUrl: new URL(env.scheduleUrl ?? 'https://data-api-next.benzinga.com/rest/'),

    shortInterestKey: env.shortInterestKey ?? '',
    shortInterestUrl: new URL(env.shortInterestUrl ?? 'https://data-api.benzinga.com/'),

    socketUrl: new URL(env.socketUrl ?? 'wss://pro-quote-v2.benzinga.com/quote/'),

    symbolsKey: env.symbolsKey ?? '',
    symbolsUrl: new URL(env.symbolsUrl ?? 'https://data-api-pro.benzinga.com/rest/'),

    tickersKey: env.tickersKey ?? '',
    tickersUrl: new URL(env.tickersUrl ?? 'https://data-api-next.benzinga.com/rest/'),
  });
}
